import { Injectable } from '@angular/core';
import { GeoDirect } from '../class/Geo';
import { ApiService } from './api.service';
import { BaseService } from './base.service';
@Injectable({
  providedIn: 'root',
})
export class GeoDirectService extends BaseService<Array<GeoDirect>> {
  constructor(apiService: ApiService) {
    super(apiService);
  }

  public override HandleResponse(response: JSON): Array<GeoDirect> {
    const resp = response['geodirect']['data'];
    const index = new Array();

    for (let r in resp) {
      const g = new GeoDirect(resp[r]);
      index[r] = g;
    }
    return index;
  }
}
